import React from "react";

const NativeInputField = (props) => {
  const {
    input: { value, name, onChange, onBlur },
    meta: { touched, error, warning },
    label,
    type,
    errorName,
    className,
    ...rest
  } = props;

  return (
    <div>
      <input type={type} onBlur={onBlur} className={className} name={name} value={value} onChange={(e) => onChange(e.target.value)} {...rest} />
      {touched &&
        ((error && (
          <span className="text-danger">
            {label ? label : errorName ? errorName : name} {error}
          </span>
        )) ||
          (warning && <span className="text-warning">{warning}</span>))}
    </div>
  );
};

NativeInputField.defaultProps = {
  type: "text",
  className: "w-100",
};

export default NativeInputField;
